import { render, staticRenderFns } from "./Liquidfill.vue?vue&type=template&id=004e6453&scoped=true"
import script from "./Liquidfill.vue?vue&type=script&lang=js"
export * from "./Liquidfill.vue?vue&type=script&lang=js"
import style0 from "./Liquidfill.vue?vue&type=style&index=0&id=004e6453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e6453",
  null
  
)

export default component.exports